import { useContext } from 'react';
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import { AvisoRelatorioPronto } from "./components/AvisoRelatorioPronto";
import { SidebarContext } from '../../providers/SidebarProvider';
import { ChildrenDto } from "../../types";

export function Layout({ children }: ChildrenDto) {
    const { isOpen } = useContext(SidebarContext);

    return (
        <main>
            <Sidebar />
            <AvisoRelatorioPronto />
            <section className={`content-view${isOpen ? '' : ' content-view--recolhida'}`}>
                <Header />
                <div className="main-view">
                    {children}
                </div>
            </section>
        </main>
    )
}